import useSWR from "swr";
import ScaleLoader from 'react-spinners/ScaleLoader';
import VirtualTable from "../custom/VirtualTable";
import apiClient from "../../apiClient";
import { Manual } from "../../globals/interfaces";
import Card from "../custom/Card";
import { useEffect, useState } from "react";
import ModalManual from "./ModalManual";
import useUser from "../../customHooks/useUser";
import { checkInternalUser, notify } from "../../utils";
import useAppData from "../../customHooks/useAppData";

export default function Manuals() {

    const { user } = useUser();
    const internalUser = checkInternalUser(user.s_email);
    const { manuals, loading } = useAppData();
    const [modal, setModal] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    const manual = manuals.find(manual => manual.id === selectedId);

    const handleViewManual = (id: number) => {
        setSelectedId(id);
        setModal(true);
    }

    if (!internalUser) return null;

    return (
        <Card className={'mt-2'}>
            <h3>Select Manual</h3>
            {
                loading ? (
                    <ScaleLoader color={'#6fb327'} />
                ) : (
                    <VirtualTable<Manual>
                        data={manuals}
                        mapping={[{
                            name: 'Name',
                            value: 'name'
                        }]}
                        enableClick
                        handleClick={item => handleViewManual(item.id)}
                    />
                )
            }
            <ModalManual
                modal={modal}
                setModal={setModal}
                manual={manual}
            />
        </Card>
    );
}